export default __webpack_public_path__ + "static/media/care-professionals.78afeb10.svg";